import { Link } from "react-router-dom";
import pakaian from "../images/kaospolos.jpg";
import kecantikan from "../images/skincare.jpeg";
import mainan from "../images/mainan.png";
import perabotan from "../images/peralatandapur.jpg";
import elektronik from "../images/elektronik.jpg";
import makanan from "../images/makanan.png";
import aksesoris from "../images/aksesoris.jpg";
import kesehatan from "../images/produkherbal.png";
import olahraga from "../images/dumbell.jpg";
const Katalog = () => {
  return (
    <section className="katalog-container">
      <p className="katalogTitle">Kategori UMKM</p>

      <div className="katalog-Row">
        <div className="katalog-card">
          <img className="katalog-cardImage" src={pakaian} alt="" />
          <Link to="/KatalogUMKM">
            <h2>Pakaian</h2>
          </Link>
        </div>

        <div className="katalog-card">
          <img className="katalog-cardImage" src={kecantikan} alt="" />
          <h2>Kecantikan</h2>
        </div>

        <div className="katalog-card">
          <img className="katalog-cardImage" src={mainan} alt="" />
          <h2>Mainan</h2>
        </div>
      </div>

      <div className="katalog-Row">
        <div className="katalog-card">
          <img className="katalog-cardImage" src={perabotan} alt="" />
          <h2>Perabotan</h2>
        </div>

        <div className="katalog-card">
          <img className="katalog-cardImage" src={elektronik} alt="" />
          <h2>Elektronik</h2>
        </div>

        <div className="katalog-card">
          <img className="katalog-cardImage" src={makanan} alt="" />
          <h2>Makanan</h2>
        </div>
      </div>

      <div className="katalog-Row">
        <div className="katalog-card">
          <img className="katalog-cardImage" src={aksesoris} alt="" />
          <h2>Aksesoris</h2>
        </div>

        <div className="katalog-card">
          <img className="katalog-cardImage" src={kesehatan} alt="" />
          <h2>Herbal</h2>
        </div>

        <div className="katalog-card">
          <img className="katalog-cardImage" src={olahraga} alt="" />
          <h2>Olahraga</h2>
        </div>
      </div>
    </section>
  );
};

export default Katalog;
